<template>
  <span><slot></slot>{{ this.dateText }}</span>
</template>

<script>
export default {
  name: "TzTime",
  props: ["date", "format"],
  data() {
    return {
      dateText: this.date.replace("-", "/").replace("-", "/"),
    };
  },
  mounted() {
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    var daysShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const tz =
      Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/London";

    const dGMT = new Date(this.dateText);
    const dUTC = new Date(
      Date.UTC(
        dGMT.getFullYear(),
        dGMT.getMonth(),
        dGMT.getDate(),
        dGMT.getHours(),
        dGMT.getMinutes(),
        dGMT.getSeconds(),
        dGMT.getMilliseconds()
      )
    );

    const time = new Date(
      dUTC.toLocaleString("en-US", {
        timeZone: tz,
      })
    );

    var formatDate = function (timestamp) {
      var date = new Date(timestamp);

      let dayOfWeek = daysShort[date.getDay()];
      let month = months[date.getMonth()];

      let hour = date.getHours() > 9 ? date.getHours() : `${date.getHours()}`;
      if (hour == "0") {
        hour = "00";
      }
      let minute =
        date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;

      return `${dayOfWeek}, ${month} ${date.getDate()}, ${hour}:${minute}`;
    };

    const format = this.format;

    var formatDateRedesign = function (timestamp) {
      var date = new Date(timestamp);

      let dayOfWeek = days[date.getDay()];

      let month = months[date.getMonth()];

      let twelvehour =
        date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let ampm = date.getHours() >= 12 ? "PM" : "AM";

      let hour = twelvehour > 9 ? twelvehour : `${twelvehour}`;

      if (hour == "0") {
        hour = "00";
      }

      let minute =
        date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;

      let tzOffset = date
        .toString()
        .match(/([A-Z]+[\+-][0-9]+)/)
        .map((tz) => tz.substr(0, tz.length - 2))[1];

      if (format && format == "redesign-small") {
        return `${date.toLocaleDateString()} | ${hour}:${minute} ${ampm} (${tzOffset})`;
      } else if (format && format == "new-redesign-date") {
        return `${month} ${date.getDate()}. ${date.getFullYear()}`;
      } else if (format && format == "new-redesign-time") {
        return `${hour}:${minute} ${ampm}`;
      }

      return `${dayOfWeek} | ${hour}:${minute} ${ampm} | ${month} ${date.getDate()} | ${date.getFullYear()}`;
    };

    var formatDateRedesign2 = function (timestamp) {
      var date = new Date(timestamp);

      let dayOfWeek = days[date.getDay()];

      let month = months[date.getMonth()];

      let twelvehour =
        date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let ampm = date.getHours() >= 12 ? "PM" : "AM";

      let hour = twelvehour > 9 ? twelvehour : `${twelvehour}`;

      if (hour == "0") {
        hour = "00";
      }

      let minute =
        date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;

      let tzOffset = date
        .toString()
        .match(/([A-Z]+[\+-][0-9]+)/)
        .map((tz) => tz.substr(0, tz.length - 2))[1];

      return `${date.getDate()} ${month} ${date.getFullYear()} | ${hour}:${minute} ${ampm} ${tzOffset}`;
    };

    if (this.format && this.format.includes("redesign2")) {
      this.dateText = formatDateRedesign2(time);
    } else if (this.format && this.format.includes("redesign")) {
      this.dateText = formatDateRedesign(time);
    } else {
      this.dateText = formatDate(time);
    }
  },
};
</script>

<style scoped>
</style>
